var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshareNotification = function SvgScreenshareNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#screenshare-notification_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#screenshare-notification_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.641 11.5H11.36A2.859 2.859 0 0 0 8.5 14.359v7.282a2.859 2.859 0 0 0 2.859 2.859H24.64a2.859 2.859 0 0 0 2.859-2.859V14.36a2.859 2.859 0 0 0-2.859-2.859ZM11.36 10A4.359 4.359 0 0 0 7 14.359v7.282A4.359 4.359 0 0 0 11.359 26H24.64A4.359 4.359 0 0 0 29 21.641V14.36A4.359 4.359 0 0 0 24.641 10H11.36Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.198 16.42 3.34-3.229a.691.691 0 0 1 .953 0l3.311 3.228a.637.637 0 0 1 0 .922.691.691 0 0 1-.954 0l-2.159-2.114v7.12c0 .361-.302.653-.674.653a.664.664 0 0 1-.675-.652v-7.121l-2.188 2.114a.691.691 0 0 1-.954 0 .637.637 0 0 1 0-.922Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenshare-notification_svg__a",
    x1: 0.405,
    y1: 0.81,
    x2: 0.405,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6584ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A43B8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "screenshare-notification_svg__b",
    x: -3.897,
    y: -0.897,
    width: 43.795,
    height: 37.795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 5.449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8061_17248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_8061_17248",
    result: "shape"
  })))));
};
export default SvgScreenshareNotification;